import LocalStorage from './LocalStorage';
import SpecificComponent from '../commons/SpecificComponent';
import Masks from './Masks';

// import aes from 'crypto-js/aes'
// import * as aesjs from '../libs/aes'

export default class Utils extends SpecificComponent {


    M = new Masks()

    randomData = (nr) => {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < nr; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }


    getRandomArray(arr, n) {
        var result = new Array(n),
            len = arr.length,
            taken = new Array(len);
        if (n > len)
            throw new RangeError("getRandom: more elements taken than available");
        while (n--) {
            var x = Math.floor(Math.random() * len);
            result[n] = arr[x in taken ? taken[x] : x];
            taken[x] = --len in taken ? taken[len] : len;
        }
        return result;
    }

    generateListaZile = (dateStart, dateEnd) => {

        // console.log("Generating lista zile from", dateStart, " to ", dateEnd)

        if (dateStart.getTime() > dateEnd.getTime()) {
            console.error("Err genrrate lista zile: data start trebuie sa fie mai mica decat dataEnd")
            return null;
        }

        //let M = new Masks()

        let rez = []
        let iteratingDate = dateStart

        let maxCounter = 0;
        const comparingDate = this.M.addDaysToDate(dateEnd, 1)
        while (this.M.datesAreEgual(iteratingDate, comparingDate) === false && maxCounter < 1000) {

            rez.push(iteratingDate)

            iteratingDate = this.M.addDaysToDate(iteratingDate, 1)
            maxCounter++;
        }

        return rez;
    }



    alfabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']

    luni = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie']

    luniPrescurtate = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sept', 'Oct', 'Noi', 'Dec']


    statusAngajati = ['Activ', 'Candidat', 'In Curs de Angajare']
    tipuriEvaluare = [
        { id: 1, nume: 'Un angajat specific' },
        { id: 2, nume: 'Un departament' },
        { id: 3, nume: 'Toata compania' }
    ]

    nvelResponsabilitate = [
        { id: 1, n: 'Administrator' },
        { id: 2, n: 'Responsabil Proiect' },
        { id: 3, n: 'Utilizator Cu Drepturi Obisnuite' }
    ]

    colorFurnizoriClienti = {
        furnizor: '#904807',
        client: '#0f83dc'
    }


    transformTimeFromSql = (time) => {
        let t = time.substring(0, time.length - 3)

        return t
    }

    nivelEducatei = [
        'Scoala Primara',
        'Gimnaziu',
        'Liceu',
        'Facultate',
        'Postuniversitate'
    ]

    stiluriViata = [
        'Sedentar',
        'Sanatos',
        'Traditional',
        'Social Liberal',
        'Social Conservator'
    ]

    culoriUtilizatori = (id) => {
        let culori = [
            'rgb(240 180 247)',
            'rgb(254 193 53)',
            'rgb(113 227 255)',
            'rgb(157 168 255)',
            'rgb(253 159 162)',
            'rgb(113 227 255)'
        ]

        // console.log('culori :>> ', culori[id%6])


        return culori[id % 6]
    }

    getZile = (luna) => {
        let counter = 30

        switch (luna) {
            case 1:
                counter = 31
                break;
            case 2:
                counter = 28
                break;
            case 3:
                counter = 31
                break;
            case 4:
                counter = 30
                break;
            case 5:
                counter = 31
                break;
            case 6:
                counter = 30
                break;
            case 7:
                counter = 31
                break;
            case 8:
                counter = 31
                break;
            case 9:
                counter = 30
                break;
            case 10:
                counter = 31
                break;
            case 11:
                counter = 30
                break;
            default:
                counter = 31
                break;
        }

        let days = []

        for (let i = 0; i < counter; i++) {
            days.push(i + 1)
        }

        return days
    }


    replaceDiacritice = (str) =>{

     

      let newStr =  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

     newStr = newStr.replaceAll(/\s/g,'')

    //   console.log('newStr :>> ', newStr);


      newStr = newStr.replace(/\\n/g, '')

      return newStr

    }


    tipConcedii = [
        
        { id: 'absenta_nemotivata', nume: this.dictionary.pontaje.absentaNemotivata, bkColor: 'rgb(227 51	59)', color: 'white' },
        { id: 'absenta_invoire', nume: this.dictionary.pontaje.absentaInvoire, bkColor: 'rgb(206, 152, 79)', color: 'white', alias: 'AI' },
        { id: 'invoire', nume: this.dictionary.pontaje.invoireFaraAbsenta, bkColor: 'rgb(112 227 255)', color: 'white', alias: 'IV' },
        { id: 'ore_suplimentare', nume: this.dictionary.pontaje.oreSuplimentare, bkColor: 'rgb(14 111 28)', color: 'white', alias:'OS' },
        { id: 'concediu_fara_plata', nume: this.dictionary.pontaje.cFaraPlata, bkColor: 'rgb(250 113 117)', color: 'white', alias: 'CFP' },
        { id: 'concediu_odihna', nume: this.dictionary.pontaje.cOdihna, bkColor: 'rgba(38	120	227	)', color: 'white', alias: 'CO' },
        { id: 'concediu_medical', nume: this.dictionary.pontaje.cMedicalAccident, bkColor: 'rgb(252 99	7)', color: 'white', alias: 'CM' },
        { id: 'concediu_ingrijire_copil', nume: this.dictionary.pontaje.cMaternitate, bkColor: 'rgb(241 23 168)', color: 'white', alias: 'CI' },
        { id: 'evenimente_speciale', nume: this.dictionary.pontaje.cEvenimenteSpeciale, bkColor: 'rgb(238	231	24)', color: 'white', alias: 'ES' },
        { id: 'preaviz', nume: this.dictionary.pontaje.cAcomodare, bkColor: 'rgb(21	164	191)', color: 'white', alias: 'PR' },
        

    ]

    tipIntrebari = [
        {
            id: 'radio',
            nume: 'O singura varianta de raspuns'
        },
        {
            id: 'checkbox',
            nume: 'Raspuns Multiplu'
        },
        {
            id: 'text',
            nume: 'Text Liber'
        },
        {
            id: 'img_single',
            nume: 'O singura varianta de raspuns de timp imagine'

        },
        {
            id: 'img_multiple',
            nume: 'Raspuns multiplus de timp imagine'

        },
    ]


    typeOfCharts = [
        'Vertical',
        'Line',
        'Bubble',
        'Pie',
        'Horizontal',
        'Doughnut',
        'Radar',
        'Polar Area'
    ]


    documenteHR = [
        { id: 'cereri_diverse', nume: 'Cereri Diverse' },
        { id: 'adeverinte', nume: 'Adeverinte' },
        { id: 'fisa_de_post', nume: 'Fisa de post' },
        { id: 'instructiuni', nume: 'Instructiuni' }
    ]


    sortByUserReports = [
        { id: 'nrTotalTaskuri', nume: 'Nr total taskuri' },
        { id: 'nrTaskuriDepasite', nume: 'Nr taskuri depsite' },
        { id: 'nrTaskuriAvans', nume: 'Nr taskuri avans' },
        { id: 'nrTaskuriInTermen', nume: 'Nr taskuri in termen' },
        { id: 'totalOreDepasire', nume: 'Nr taskuri ore depasire' },
        { id: 'totalOreAvans', nume: 'Nr taskuri ore avans' },
        { id: 'medieDepasirePerTask', nume: 'Medie depasire / task' },
        { id: 'medieAvansPerTask', nume: 'Medie avans / task' },
        { id: 'medieGenerala', nume: 'Medie generala' },
        { id: 'calificativMedie', nume: 'Calificativ medie' },
        { id: 'totalOreCumulateTaskuri', nume: 'Total ore cumulate taskuri' },
        { id: 'totalOreDiferentaCompletare', nume: 'Total ore diferenta completare' },
        { id: 'pctDepasire', nume: 'Procentaj depasire taskuri' },


    ]

    sortByTasksReport = [
        { id: 'nume_user', nume: 'Nume utilizator' },
        { id: 'nume_proiect', nume: 'Nume proiect' },
        { id: 'durata_ore', nume: 'Durata ore' },
        { id: 'ore_depasire', nume: 'Ore depasire' },
        { id: 'ore_avans', nume: 'Ore avans' }

    ]


    generateId = () => {
        return this.randomData(32);
    }

    culoriDepartamente = [
        'rgb(46, 136, 232)',
        'rgba(178, 64, 214, 0.91)',
        'rgb(70, 210, 82)',
        'rgba(239, 38, 38, 0.88)',
        'rgba(253, 73, 155, 0.9)',
        'rgb(200, 230, 42)',
        'rgb(54, 211, 220)',

    ]

    culoriRaspunsuri = () => {




        let listCulori = [
            { id: 'rgba(5, 62, 123, .6)', nume: 1 },
            { id: 'rgba(29, 123, 5, 0.6)', nume: 2 },
            { id: 'rgba(123, 5, 93, 0.6)', nume: 3 },
            { id: 'rgba(182, 49, 9, 0.6)', nume: 4 },
            { id: 'rgba(165, 167, 49, 0.6)', nume: 5 },
            { id: 'rgba(116, 206, 120, 0.6)', nume: 6 },
            { id: 'rgba(199, 19, 73, 0.6)', nume: 7 },
            { id: 'rgba(94, 51, 194, 0.6)', nume: 8 },
            { id: 'rgba(26, 155, 127, 0.6)', nume: 9 }

        ]

        return listCulori
    }

    changeCuloriRaspunsuri = (idProiect) => {

        let culori = ['rgba(5, 62, 123, .6)',
            'rgba(29, 123, 5, 0.6)',
            'rgba(123, 5, 93, 0.6)',
            ' rgba(182, 49, 9, 0.6)',
            'rgba(165, 167, 49, 0.6)',
            'rgba(116, 206, 120, 0.6)',
            'rgba(199, 19, 73, 0.6)',
            'rgba(94, 51, 194, 0.6)',
            'rgba(26, 155, 127, 0.6)']

        return culori[idProiect % 9]
    }


    culoriTaskuri = () => {

        let listCulori = []



        if (this.dictionary.data === 'en') {

            listCulori = [
                { id: 'rgb(108, 96, 197)', nume: 'Default' },
                { id: '#7ad13a', nume: 'High Priority' },
                { id: 'rgb(247, 167, 16)', nume: 'Working on it' },
                { id: '#ff3f3f', nume: 'Blocked' },

            ]

        } else {

            listCulori = [
                { id: 'rgb(108, 96, 197)', nume: 'Default' },
                { id: '#7ad13a', nume: 'Prioritar' },
                { id: 'rgb(247, 167, 16)', nume: 'In Desfasurare' },
                { id: '#ff3f3f', nume: 'Blocat' },
            ]

        }

        return listCulori
    }


    renameKeysInObject = (obj, newKeys) => {
        const keyValues = Object.keys(obj).map(key => {
            const newKey = newKeys[key] || key;
            return { [newKey]: obj[key] };
        });

        return Object.assign({}, ...keyValues);
    }

    renameKeysInArray = (arr, newKeys) => {

        for (let el in arr) {
            // console.log('element este: ', arr[el])
            arr[el] = this.renameKeysInObject(arr[el], newKeys)
            // console.log('element devine ', arr[el])
        }

        return arr
    }

    translateHeaderData = (listaDeTradus, dictionar) => {
        //let dictionar = this.dictionary.licitatii.capLista

        let newKeys = {}
        for (let k in dictionar) {
            newKeys[k] = dictionar[k]
        }

        let newObject = this.renameKeysInArray(listaDeTradus, newKeys)
        return newObject
    }

    translateArray = (arr, dict) => {
        //  ATENTIE: VA MANIPULA PRIN REFERINTA ARRAYUL PRIMIT !!!

        for (let el in arr) {
            if (dict[arr[el]]) {
                arr[el] = dict[arr[el]]
            }
        }
        return arr
    }

    checkModuleAvailable = (modul, activeLog = null) => {
        let LS = new LocalStorage()
        let setari = LS.GetSetariComerciant()

        if (setari) {
            // tabela setari include codurile 
            let allowAccess = false
            switch (modul) {
                case 'Licitatii':
                    allowAccess = setari.l1 === 'Da';
                    break;
            }

            if (activeLog) {
                // console.log('Utils --> verificare module --> Setari comerciant :: ', setari)
                // console.log(`Utils --> verificare module --> Pt modul ${modul} functia va returna: ${allowAccess}`)    
            }
            return allowAccess
        }
        else
            return null;
    }

    checkUserRights = (modul, functie, activeLog = null) => {

        let LS = new LocalStorage()
        let userRights = LS.GetUserRights()

        if (userRights.IsAdmin) {
            if (activeLog) {
                // console.log('Utils --> verificare user rights --> Userul este admin, se va returna true')
            }
            return true
        }

        let allowAccess = false

        if (modul === 'Licitatii') {

            switch (functie) {
                case 'Lista':
                    allowAccess = userRights.AccessLicitatii || false
                    break;
                case 'Add':
                    allowAccess = userRights.CreazaLicitatii || false
                    break;
            }
        }
        // end modul licitatii

        if (activeLog) {
            //  console.log('Utils --> verificare user rights --> Obiectul user rights este :: ', userRights)
            // console.log(`Utils --> verificare  user rights --> Pt modul ${modul} cu functie ${functie} verificarea va returna: ${allowAccess}`)
        }

        return allowAccess

    }

    checkAccessToModule = (modul, functie, dictionar, activeLog = null) => {

        let _allowModule = this.checkModuleAvailable(modul, activeLog)

        if (_allowModule) {

            let _allowUser = this.checkUserRights(modul, functie, activeLog)

            if (_allowUser) {
                return {
                    hasAccess: true,
                    headMessage: '',
                    textMessage: ''
                }
            }
            else {
                return {
                    hasAccess: false,
                    headMessage: dictionar.comune.accesBlocatHead,
                    textMessage: dictionar.comune.accesBlocatText
                }
            }

        }
        else {
            return {
                hasAccess: false,
                headMessage: dictionar.comune.modulIndisponibilHead,
                textMessage: dictionar.comune.modulIndisponibilText
            }
        }
    }


    dataAzi = () => {


        let dataAzi = this.defaultData()

        if (this.dictionary.date === 'en') {
            return this.dataPrescurtataEng(dataAzi)
        } else {
            return this.dataPrescurtataRomana(dataAzi)
        }
    }


    getLast10Years = () => {


        let strYear = new Date().getFullYear()

        let nrCounter = 10

        let listYears = []

        for (let i = 0; i < nrCounter; i++) {
            listYears.push(strYear - i-1)
        }


        return listYears

    }

    getLast10YearsIncludingThisYear = () =>{
        let strYear = new Date().getFullYear()

        let nrCounter = 10

        let listYears = []

        for (let i = 0; i < nrCounter; i++) {
            listYears.push(strYear - i)
        }


        return listYears
    }


    getAllDaysInMonth = (y, m ) =>{

        let allDays = []

        for(let i = 0, n = new Date(y, m, 0).getDate(); i<n ; i++   ){
            allDays.push(i + 1)
        } 

        console.log('allDays :>> ', allDays);

        return allDays

    }



    getDaysInMonth = (year, month) => {

 



        return new Date(year, month, 0).getDate();

    }

    getLast4Years = () => {


        let strYear = new Date().getFullYear()

        let nrCounter = 4

        let listYears = []

        for (let i = 0; i < nrCounter; i++) {
            listYears.push(strYear - i)
        }

        return listYears

    }

    getMonths = [
        { id: 1, luna: 'Ianuarie' },
        { id: 2, luna: 'Februarie' },
        { id: 3, luna: 'Martie' },
        { id: 4, luna: 'Aprilie' },
        { id: 5, luna: 'Mai' },
        { id: 6, luna: 'Iunie' },
        { id: 7, luna: 'Iulie' },
        { id: 8, luna: 'August' },
        { id: 9, luna: 'Septembrie' },
        { id: 10, luna: 'Octombrie' },
        { id: 11, luna: 'Noiembrie' },
        { id: 12, luna: 'Decembrie' }
    ]

    addDays = (date, days) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    yearsPlus5 = () => {
        let strYear = new Date().getFullYear()

        let nrCounter = 6

        let listYears = []

        for (let i = 0; i < nrCounter; i++) {
            listYears.push(strYear + i)
        }

        return listYears
    }


    dataAfisata = (data) => {

        if (this.dictionary.date === 'en') {
            return this.dataPrescurtataEng(data)
        } else {
            return this.dataPrescurtataRomana(data)
        }
    }


    colorObject = () => {
        let arr = [
            {
                serverLabel: '1',
                label: this.dictionary.financiarContabil.rau,
                color: 'red'
            },
            {
                serverLabel: '2',
                label: this.dictionary.financiarContabil.slab,
                color: 'rgb(251, 141, 0)'
            },
            {
                serverLabel: '3',
                label: this.dictionary.financiarContabil.bun,
                color: 'rgb(122, 209, 58)'
            },
            {
                serverLabel: '4',
                label: this.dictionary.financiarContabil.foarteBun,
                color: 'rgb(122, 209, 58)'
            }

        ]

        return arr
    }


    sortBy = [
        { id: 1, val: 'Nr Taskuri' },
        { id: 2, val: 'Nr Taskuri Depasite' },
        { id: 3, val: 'Taskuri finalizate in termen' }
    ]



    conturi = [{ tip: 'venit', conturi: [] }]



    valoriTva = [0, 5, 9, 19]

    transformDataForSql = (data) => {


        let myDate = new Date(data)

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`

    }

    transformDataPoints = (data) => {


        let myDate = new Date(data)

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}.${month}.${day}`

    }

    ParseDataFromSql = (d) => String(d).substring(0, 10)

    ParseOraFromSql = (d) => String(d).substring(11, 16)


    defaultData = () => {
        let myDate = new Date()

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    defaultDataPlus3Months = () => {
        let myDate = new Date()

        myDate.setMonth(myDate.getMonth() + 3)


        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    defaultDataMinus1Months = (date) => {


        let myDate

        if (date) {
            myDate = new Date(date)
        } else {
            myDate = new Date()
        }

        myDate.setMonth(myDate.getMonth() - 1)


        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    defaultDataPlus1Months = (date) => {
        let myDate

        if (date) {
            myDate = new Date(date)
        } else {
            myDate = new Date()
        }

        myDate.setMonth(myDate.getMonth() + 1)


        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }


    defaultDataPlus7Days = () => {
        let myDate = new Date()

        myDate.setDate(myDate.getDate() + 7);

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    getTimeNow = () => {
        let date = new Date();

        let hour = (date.getHours() < 10 ? `0${date.getHours()}` : date.getHours())
        let min = (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes())

        return `${hour}:${min}`
    }


    getElapsedTime = (time, date, timeEnd = null, secs) => {
        let ti = time.split(':')

        let oldDate = date;

        oldDate = oldDate.setHours(ti[0])
        oldDate = new Date(oldDate)
        oldDate = oldDate.setMinutes(ti[1])
        oldDate = new Date(oldDate)
        oldDate = oldDate.setSeconds(secs)
        oldDate = new Date(oldDate)


        // console.log('new Date(oldDate) :', new Date(oldDate));

        let newDate;

        if (timeEnd) {

            // console.log('timeEnd :', timeEnd);
            let ti2 = timeEnd.split(':')

            newDate = new Date(date)
            newDate = newDate.setHours(ti2[0])
            newDate = new Date(newDate)
            newDate = newDate.setMinutes(ti2[1])
            newDate = new Date(newDate)
            newDate = newDate.setSeconds(secs)
            newDate = new Date(newDate)


        } else {
            newDate = new Date()
        }




        let difference = newDate.getTime() - oldDate.getTime()

        let hours = Math.floor(difference / 3.6e6);
        let minutes = Math.floor((difference % 3.6e6) / 6e4) < 10 ? `0${Math.floor((difference % 3.6e6) / 6e4)}` : Math.floor((difference % 3.6e6) / 6e4)
        let seconds = Math.floor((difference % 6e4) / 1000) < 10 ? `0${Math.floor((difference % 6e4) / 1000)}` : Math.floor((difference % 6e4) / 1000)

        // console.log('hours :', hours);
        // console.log('minutes :', minutes);

        // console.log('seconds :', seconds);

        // console.log('difference :', difference);


        // console.log('ti :', ti);

        return `${hours}:${minutes}:${seconds}`




    }

    getMonday = (d) => {
        let date = new Date(d);
        let day = date.getDay();
        let diff = date.getDate() - day + (day === 0 ? -6 : 1);

        return new Date(date.setDate(diff));
    }

    getDatePercent = (data, data2) => {

        let defaultDate = new Date()

        let myDate1 = new Date(data)

        let myDate2 = new Date(data2)


        // console.log('defaultDate :', defaultDate);
        // console.log('myDate1 :', myDate1);
        // console.log('myDate2 :', myDate2);

        // console.log('defaultDate.getDate() :', defaultDate.getTime());
        // console.log('myDate2.getDate() :', myDate2.getTime());

        let full = myDate2.getTime() - myDate1.getTime()

        if (defaultDate <= myDate2) {

            let today = defaultDate.getTime() - myDate1.getTime()

            //  console.log('full :', full);
            //  console.log('today :', today);

            let percent = Math.floor((today / full) * 100)

            // console.log('percent :', percent);

            return `${percent}%`
        } else {
            return `100%`
        }



    }

    generateRaspunsuri = () => {
        let counter = 100


        let raspunsuri = { id: 9, optiuniRaspuns: [] }

        for (let i = 1; i <= counter; i++) {
            raspunsuri.optiuniRaspuns.push({ Label: `${i}`, Puncte: i })

        }
        return raspunsuri
    }

    raspunsuriPredefinite = [
        {
            id: 1,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: 0 }]
        },

        {
            id: 2,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da', Puncte: 1 },
            { Label: 'Ns/Nr', Puncte: 0 },
            { Label: 'Nu', Puncte: -1 }]
        },
        {
            id: 3,
            edit: 0,
            tip: 'img_single',
            optiuniRaspuns: [{ Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 }]
        },
        {
            id: 4,
            edit: 0,
            tip: 'img_multiple',
            optiuniRaspuns: [{ Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 }]
        },
        {
            id: 5,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 }]
        },
        {
            id: 6,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da++', Puncte: 3 },
            { Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Ns/Nr', Puncte: 0 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 },
            { Label: 'Nu--', Puncte: -3 }]
        },
        {
            id: 7,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da++', Puncte: 3 },
            { Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 },
            { Label: 'Nu--', Puncte: -3 }]
        },
        {
            id: 8,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: '1', Puncte: 5 },
            { Label: '2', Puncte: 4 },
            { Label: '3', Puncte: 3 },
            { Label: '4', Puncte: 2 },
            { Label: '5', Puncte: 1 },
            { Label: '6', Puncte: 0 },
            { Label: '7', Puncte: -1 },
            { Label: '8', Puncte: -2 },
            { Label: '9', Puncte: -3 },
            { Label: '10', Puncte: -4 },]
        },
        {
            id: 9,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: '1', Puncte: 2 },
            { Label: '2', Puncte: 1 },
            { Label: '3', Puncte: 0 },
            { Label: '4', Puncte: -1 },
            { Label: '5', Puncte: -2 }]
        },
        // {
        //     id: 10,
        //     edit: 0,
        //     tip: 'text',
        //     optiuniRaspuns: [{ Label: 'Raspuns Liber...', Puncte: 0 }]
        // },




    ]

    statusulColor = (statusul) => {

        switch (statusul) {
            case 'Finalizata':
                return '#10aa2ac5'
            case 'InLucru':
                return '#ea550a';
            case 'Blocat':
                return 'red'
            default: return '#ea550a';
        }

    }

    hourDifferenceInHours = (from, to) => {
        if (to !== null && from !== null) {

            let fromArr = from.split(':');
            let toArr = to.split(':');

            let timeStart = new Date()
            let timeEnd = new Date()

            timeStart = timeStart.setHours(fromArr[0])
            timeStart = new Date(timeStart).setMinutes(fromArr[1])

            timeEnd = timeEnd.setHours(toArr[0])
            timeEnd = new Date(timeEnd).setMinutes(toArr[1])

            //   console.log('timeStart :',new Date(timeStart) );
            //   console.log('timeEnd :',new Date (timeEnd) );

            let hourDifference = timeEnd - timeStart

            //   console.log('hourDifference :', hourDifference);

            let m = Math.floor((hourDifference / (1000 * 60)) % 60)
            let h = Math.floor(hourDifference / (1000 * 60 * 60));

            m = m < 10 ? `0${m}` : m
            h = h < 10 ? `0${h}` : h

            //   console.log('h :', h);


            return  Math.floor(hourDifference / (1000 * 60 * 60))

        }
    }

    hourDifferenceInSeconds = (from, to) =>{
        if (to !== null && from !== null) {

            let fromArr = from.split(':');
            let toArr = to.split(':');

            let timeStart = new Date()
            let timeEnd = new Date()

            timeStart = timeStart.setHours(fromArr[0])
            timeStart = new Date(timeStart).setMinutes(fromArr[1])

            timeEnd = timeEnd.setHours(toArr[0])
            timeEnd = new Date(timeEnd).setMinutes(toArr[1])

            //   console.log('timeStart :',new Date(timeStart) );
            //   console.log('timeEnd :',new Date (timeEnd) );

            let hourDifference = timeEnd - timeStart

            //   console.log('hourDifference :', hourDifference);

            let m = Math.floor((hourDifference / (1000 * 60)) % 60)
            let h = Math.floor(hourDifference / (1000 * 60 * 60));

            m = m < 10 ? `0${m}` : m
            h = h < 10 ? `0${h}` : h

            //   console.log('h :', h);


            return  Math.floor(hourDifference / 1000  )

        }
    }

    hourDifference = (from, to) => {
        //   console.log('from :', from);

        //   console.log('to :', to);

        if (to !== null && from !== null) {

            let fromArr = from.split(':');
            let toArr = to.split(':');

            let timeStart = new Date()
            let timeEnd = new Date()

            timeStart = timeStart.setHours(fromArr[0])
            timeStart = new Date(timeStart).setMinutes(fromArr[1])

            timeEnd = timeEnd.setHours(toArr[0])
            timeEnd = new Date(timeEnd).setMinutes(toArr[1])

            //   console.log('timeStart :',new Date(timeStart) );
            //   console.log('timeEnd :',new Date (timeEnd) );

            let hourDifference = timeEnd - timeStart

            //   console.log('hourDifference :', hourDifference);

            let m = Math.floor((hourDifference / (1000 * 60)) % 60)
            let h = Math.floor(hourDifference / (1000 * 60 * 60));

            m = m < 10 ? `0${m}` : m
            h = h < 10 ? `0${h}` : h

            //   console.log('h :', h);


            return `${h}:${m}`

        }

    }

    culoriCharts = (id) => {

        let culori = ['rgba(166, 5, 204, 0.5)',
            'rgba(204, 5, 5, 0.5)',
            'rgba(204, 126, 5, 0.5)',
            'rgba(117, 204, 5, 0.5)',
            'rgba(5, 204, 141, 0.5)',
            'rgba(5, 138, 204, 0.5)',
            'rgba(11, 29, 162, 0.5)',
            'rgba(197, 8, 155, 0.5)',
            'rgba(9, 228, 58, 0.5)',
            'rgba(120, 69, 136, 0.5)']

        return culori[id % 10]

    }

    culoriTopButtons = (id) => {
        let culori = ['#900DCB', '#097BED', '#C8C779', '#59D862', '#3BCDFE', '#FF9A35', '#D0DD1C', '#E57577']

        return culori[id % 8]
    }

    culoriProiecte = (idProiect) => {

        let culori = ['#6f6ff3', '#dc0707ad', 'green', ' #ffa5002e', 'darkorange', 'fucsia', 'pink']


        return culori[idProiect % 7]
    }




    statusText = (dbword) => {

        let obj = {
            Finalizata: this.dictionary.proiecte.status.finalizata,
            InLucru: this.dictionary.proiecte.status.inlucru,
            Blocat: this.dictionary.proiecte.status.blocat
        }


        return obj[dbword]


    }


    removeSpaces = (str) => {
        let string = str.replace(/\s/g, '')

        return string
    }





    dataPrescurtataRomana = (data) => {

        let myDate = new Date(data);

        const luni = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec']

        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna} ${an}`

    }

    dataFull = (data = null) => {



        let myDate = data === null ? new Date() : new Date(data);

        let luni = []

        if (this.dictionary.date === 'en') {
            luni = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        } else {
            luni = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie']

        }
        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna} ${an}`
    }

    dataFullPlusDay = (data = null) => {

        let myDate = data === null ? new Date() : new Date(data);

        let luni = []
        let zile = []

        if (this.dictionary.date === 'en') {
            luni = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            zile = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

        } else {
            luni = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie']
            zile = ['Duminica', 'Luni', 'Marti', 'Miercuri', 'Joi', 'Vineri', 'Sambata']

        }
        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];
        const ziuaSapt = zile[myDate.getDay()]

        return `${ziuaSapt}, ${zi} ${luna} ${an}`

    }

    dataPrescurtataRomanaNoYear = (data) => {

        let myDate = new Date(data);

        const luni = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec']

        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna}`

    }


    dataPrescurtataEngNoYear = (data) => {

        let myDate = new Date(data);

        const luni = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna}`

    }





    dataPrescurtataEng = (data) => {

        let myDate = new Date(data);

        const luni = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna} ${an}`

    }


    getDaysDifference = (d1, d2) => {

        if (d1 !== null && d2 !== null) {
            let date1 = new Date(d1)

            let date2 = new Date(d2)

            let timeDiff = Math.abs(date2.getTime() - date1.getTime());

            let dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

            dayDiff = dayDiff === 0 ? 1 : dayDiff + 1

            return dayDiff
        } else {
            return 1
        }

    }

    toFixedIfNecessary = (value, dp) => {
        return +parseFloat(value).toFixed(dp);
    }


    compareDate = (data1, data2) => {

        let d1 = new Date(data1).setHours(0, 0, 0, 0)
        let d2 = new Date(data2).setHours(0, 0, 0, 0)

        d1 = new Date(d1)
        d2 = new Date(d2)

        if (d1.getTime() >= d2.getTime()) {
            return true
        } else {
            return false
        }
    }

    dataPoint = (dta) => {

        let data = new Date(dta)

        let year = data.getFullYear()
        let month = data.getMonth() + 1 < 10 ? '0' + (data.getMonth() + 1) : (data.getMonth() + 1)
        let day = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()

        return `${day}.${month}.${year}`
    }

    updateSqlNow = () => {

        let myDate = new Date()

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala)
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate()

        let hour = (myDate.getHours() < 10 ? '0' : '') + myDate.getHours()
        let minutes = (myDate.getMinutes() < 10 ? '0' : '') + myDate.getMinutes()

        return `${year}-${month}-${day} ${hour}:${minutes}:00`

    }

    secondsToHours = (sec) => {

        let h = sec / 3600

        return h.toFixed(2)
    }

    dayDiffConcediu = (dataStart, dataEnd, prgAngajat)=>{

        console.log('dataStart :>> ', dataStart);
        console.log('dataEnd :>> ', dataEnd);

        if(new Date(this.ParseDataFromSql(dataStart)) < new Date(this.ParseDataFromSql(dataEnd)) ){
            let dayDiff = this.getDaysDifference(dataEnd, dataStart)

            console.log('dayDiff :>> ', dayDiff);
        
    
            let listaZile = this.generateListaZile(new Date(dataStart), new Date(dataEnd))
    
            console.log('listaZile :>> ', listaZile);
    
            let programAngajat = prgAngajat
    
            console.log('programAngajat :>> ', programAngajat);
    
            for(let i = 0 , n = listaZile.length; i< n ; i++){
                let getDay = new Date(listaZile[i]).getDay()
    
                if(programAngajat.length > 0){
                    let filterProgram = programAngajat.filter(p => p.dateIdx === getDay )
    
                    if(filterProgram.length > 0){
                        dayDiff = dayDiff
                    }else{
                        dayDiff = dayDiff - 1
                    }
                }else{
                    dayDiff = dayDiff
                }
    
               
            }
    
            return dayDiff
        }else{
            return 0
        }

      
    }

    secondsToHoursAndMinutes = (sec) => {
        let h = sec / 3600

        let minutes = 0

        if (h >= 1) {
            // minutes = (h * 60)
           let min = (h + "").split(".");
            console.log('min :>> ', min);
            // console.log('min[1].substring(0,1 :>> ', min[1].substring(0,1));

             minutes = min.length > 1 ? Number(min[1].substring(0,1)) * 6 : 0
            // console.log('minutes 1 :>> ', minutes);

        } else {
            minutes = h * 60
        }

        console.log('h :>> ', h);
          console.log('minutes :>> ', minutes);



        return `${Math.floor(h)}h ${Math.floor(minutes)} min`
    }


    secondsToMinute = (sec) => {


        let minutes = sec / 60



        //   console.log('minutes :>> ', minutes);

        if (sec < 60) {
            return `${sec} sec`
        } else {
            return `${Math.floor(minutes)} min`
        }





    }


    secondsToMinutesChart = (sec) => {

        let minutes = sec / 60


        return Math.ceil(minutes)


    }


    filterMonitorizareAll = (aplicatii, appFol) => {

        let aplicatiiAllObj = { 
            
        }

        let aplicatiiFolosite = JSON.parse(JSON.stringify(appFol))

        let listaAplicatii = JSON.parse(JSON.stringify(aplicatii))

        let newAplicatii = []

        for (let j = 0, m = listaAplicatii.length; j < m; j++) {

            let aplicatiiFolositeFilter = aplicatiiFolosite.filter(aa => aa.app_id === listaAplicatii[j].hash_id &&  aa.app_id !== "i0000000000000000000000000000000");

            listaAplicatii[j]['secunde'] = aplicatiiFolositeFilter.reduce((a, c) => {
                //  console.log('   listaAplicatii[j] :>> ',    listaAplicatii[j]['hash_id'] );
                //     console.log('a :>> ', a);
                //     console.log('c.seconds_used :>> ', c.seconds_used);
                return a + c.seconds_used
            }, 0)

            // console.log('listaAplicatii[j]secunde] :>> ', listaAplicatii[j]['secunde']);


            newAplicatii.push(listaAplicatii[j])

        }


        let aplicatiiIdle = aplicatiiFolosite.filter(aa => aa.app_id === "i0000000000000000000000000000000").reduce((a, c) => {
            return a + c.seconds_used
        }, 0)

        console.log('aplicatiiIdleTotal :>> ', aplicatiiFolosite.filter(aa => aa.app_id === "i0000000000000000000000000000000"));

        aplicatiiAllObj['idle'] = aplicatiiIdle


        let appProductiveSecunde = aplicatiiFolosite.filter(aa => Number(aa.is_productive) === 1 && aa.app_id !== "i0000000000000000000000000000000").reduce((a, c) => {
            return a + c.seconds_used
        }, 0)

        let appNeproductiveSecunde = aplicatiiFolosite.filter(aa => Number(aa.is_productive) !== 1 && aa.app_id !== "i0000000000000000000000000000000").reduce((a, c) => {
            return a + c.seconds_used
        }, 0)

        let appSecondsAll = aplicatiiFolosite.reduce((a, c) => {
            return a + c.seconds_used
        }, 0)

        aplicatiiAllObj['procent_productivitate'] = (appProductiveSecunde / appSecondsAll) * 100
        aplicatiiAllObj['timp_productiv'] = appProductiveSecunde
        aplicatiiAllObj['timp_neproductiv'] = appNeproductiveSecunde
        aplicatiiAllObj['aplicatii_folosite'] = aplicatiiFolosite.filter(aa => aa.app_id !== "i0000000000000000000000000000000")

  
        aplicatiiAllObj['aplicatii_folosite_principale'] = []

        let etichete = [];

        let eticheteFilter = aplicatiiAllObj['aplicatii_folosite'].filter(app => app.eticheta !== null)

        for(let j = 0 , m = eticheteFilter.length ; j < m ; j++){

            let idx = etichete.findIndex(et => et.eticheta === eticheteFilter[j].eticheta)

            if(idx !== -1){
                etichete[idx].seconds_used += eticheteFilter[j].seconds_used
            }else{
                etichete.push(eticheteFilter[j])
            }
        }

        aplicatiiAllObj['etichete'] = etichete

        let aplicatiiFolositeCloned = JSON.parse(JSON.stringify(aplicatiiAllObj['aplicatii_folosite']))

        for(let j = 0 , m =   aplicatiiFolositeCloned.length ; j <m ; j++){
            // console.log('ang[i][aplicatii_folosite][j] :>> ', ang[i]['aplicatii_folosite'][j]);

            let idx = aplicatiiAllObj['aplicatii_folosite_principale'].findIndex(aF => aF.app_id === aplicatiiFolositeCloned[j].app_id)
          


            if(idx !== -1){

             
                    aplicatiiAllObj['aplicatii_folosite_principale'][idx].seconds_used += aplicatiiFolositeCloned[j].seconds_used
              
               
                // console.log(' aplicatiiAllObjaplicatii_folosite_merged :>> ', new Date(aplicatiiAllObj['aplicatii_folosite_merged'][idx].start_datetime).getHours() ) ;
            }else{
               
                aplicatiiAllObj['aplicatii_folosite_principale'].push(aplicatiiFolositeCloned[j])
            }

        }

       
        


        return aplicatiiAllObj

    }


    filterMonitorizareAngajati = (angajati, aplicatii, appFol, pauza = null) => {

        let ang = JSON.parse(JSON.stringify(angajati))

        let aplicatiiFolosite = JSON.parse(JSON.stringify(appFol))

        // console.log('aplicatii :>> ', aplicatii);

        for (let i = 0, n = ang.length; i < n; i++) {

            let listaAplicatii = JSON.parse(JSON.stringify(aplicatii))

            let newAplicatii = []



            for (let j = 0, m = listaAplicatii.length; j < m; j++) {

                let aplicatiiFolositeFilter = aplicatiiFolosite.filter(aa => aa.app_id === listaAplicatii[j].hash_id && Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id !== "i0000000000000000000000000000000");

                listaAplicatii[j]['secunde'] = aplicatiiFolositeFilter.reduce((a, c) => {
                    //  console.log('   listaAplicatii[j] :>> ',    listaAplicatii[j]['hash_id'] );
                    //     console.log('a :>> ', a);
                    //     console.log('c.seconds_used :>> ', c.seconds_used);
                    return a + c.seconds_used
                }, 0)

                // console.log('listaAplicatii[j]secunde] :>> ', listaAplicatii[j]['secunde']);


                newAplicatii.push(listaAplicatii[j])

            }


            let aplicatiiIdleTOTAL = aplicatiiFolosite.filter(aa => aa.app_id === "i0000000000000000000000000000000" &&  (Number(aa.id_user) === Number(ang[i].id_user)   )).reduce((a, c) => {
                return a + c.seconds_used
            }, 0)

            console.log('aplicatiiIdle angajat :>> ', aplicatiiFolosite.filter(aa => aa.app_id === "i0000000000000000000000000000000" &&  Number(aa.id_user) === Number(ang[i].id_user)));

            // console.log('aplicatiiIdle angajat  :>> ', aplicatiiIdle);
            ang[i]['idle'] = aplicatiiIdleTOTAL


            let appProductiveSecunde = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && Number(aa.is_productive) === 1 && aa.app_id !== "i0000000000000000000000000000000").reduce((a, c) => {
                return a + c.seconds_used
            }, 0)

            let appNeproductiveSecunde = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && Number(aa.is_productive) !== 1 && aa.app_id !== "i0000000000000000000000000000000").reduce((a, c) => {
                return a + c.seconds_used
            }, 0)

            let appSecondsAll = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user)).reduce((a, c) => {
                return a + c.seconds_used
            }, 0)




            // console.log('appProductiveSecunde :>> ', appProductiveSecunde);
            // console.log('appSecondsAll :>> ', appSecondsAll);
            ang[i]['procent_productivitate'] = (appProductiveSecunde / appSecondsAll) * 100
            ang[i]['timp_productiv'] = appProductiveSecunde
            ang[i]['timp_neproductiv'] = appNeproductiveSecunde
            ang[i]['aplicatii_folosite'] = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id !== "i0000000000000000000000000000000")

            ang[i]['aplicatii_folosite_merged'] = []
            ang[i]['aplicatii_folosite_principale'] = []

            // console.log('aplicatii_folosite :>> ', ang[i].aplicatii_folosite);

            let etichete = [];

            let eticheteFilter = ang[i]['aplicatii_folosite'].filter(app => app.eticheta !== null)

            for(let j = 0 , m = eticheteFilter.length ; j < m ; j++){

                let idx = etichete.findIndex(et => et.eticheta === eticheteFilter[j].eticheta)

                if(idx !== -1){
                    etichete[idx].seconds_used += eticheteFilter[j].seconds_used
                }else{
                    etichete.push(eticheteFilter[j])
                }
            }

            // console.warn('etichete :>> ', etichete);


            ang[i]['etichete'] = etichete
            let aplicatiiFolositeCloned = JSON.parse(JSON.stringify(ang[i]['aplicatii_folosite']))

            for(let j = 0 , m =   ang[i]['aplicatii_folosite'].length ; j <m ; j++){

                // let idx = ang[i]['aplicatii_folosite_merged'].findIndex(aF => aF.details === ang[i]['aplicatii_folosite'][j].details)
              


                // if(idx !== -1){
                
                //     ang[i]['aplicatii_folosite_merged'][idx].seconds_used += ang[i]['aplicatii_folosite'][j].seconds_used
                  
                    
                //     // console.log(' ang[i]aplicatii_folosite_merged :>> ', new Date(ang[i]['aplicatii_folosite_merged'][idx].start_datetime).getHours() ) ;
                // }else{
                    ang[i]['aplicatii_folosite_merged'].push(ang[i]['aplicatii_folosite'][j])
                // }

            }

            for(let j = 0 , m =   aplicatiiFolositeCloned.length ; j <m ; j++){
                // console.log('ang[i][aplicatii_folosite][j] :>> ', ang[i]['aplicatii_folosite'][j]);

                let idx = ang[i]['aplicatii_folosite_principale'].findIndex(aF => aF.app_id === aplicatiiFolositeCloned[j].app_id)
              


                if(idx !== -1){

                 
                        ang[i]['aplicatii_folosite_principale'][idx].seconds_used += aplicatiiFolositeCloned[j].seconds_used
                  
                   
                    // console.log(' ang[i]aplicatii_folosite_merged :>> ', new Date(ang[i]['aplicatii_folosite_merged'][idx].start_datetime).getHours() ) ;
                }else{
                   
                    ang[i]['aplicatii_folosite_principale'].push(aplicatiiFolositeCloned[j])
                }

            }


            ang[i]['productivity_hourly'] = []

            for(let j = 0 , m = 24 ; j < m ; j ++){

                let p = 0

                // console.log('pauza :>> ', pauza);
                if(pauza){
                    let pauzaOra = Number(pauza.pauza_start.substring(0,2))

                    // console.log('pauzaOra :>> ', pauzaOra);

                    if(pauzaOra === j){
                        p = pauza.time
                    }

                    
                }


                let aplicatiiOra = []
                

                 aplicatiiOra = ang[i]['aplicatii_folosite_merged'].filter(app => new Date(app.start_datetime).getHours() === j)

                // console.log('aplicatiiOra :>> ', aplicatiiOra);

                // console.log('aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id === "i0000000000000000000000000000000" && new Date(aa.start_datetime).getHours() === j) :>> ', aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id === "i0000000000000000000000000000000" && new Date(aa.start_datetime).getHours() === j));

                let aplicatiiIdleFilter = []

               let  aplicatiiIdleAll = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id === "i0000000000000000000000000000000")

                for(let k = 0 , o = aplicatiiIdleAll.length ; k < o ; k++){

                    if(new Date(aplicatiiIdleAll[k].start_datetime).getHours() === j &&  new Date(aplicatiiIdleAll[k].end_datetime).getHours() === j){
                        aplicatiiIdleFilter.push(aplicatiiIdleAll[k])
                    }else if(new Date(aplicatiiIdleAll[k].start_datetime).getHours() === j && new Date(aplicatiiIdleAll[k].end_datetime).getHours() > j){


                        let hourEnd = (j+1) >= 10 ? `${j+1}:00` : `0${j+1}:00`
                        let hStart = new Date(aplicatiiIdleAll[k].start_datetime).getHours() 

                        hStart = hStart >= 10 ? hStart : `0${hStart}`

                        let mStart = new Date(aplicatiiIdleAll[k].start_datetime).getMinutes()

                        mStart =  mStart >= 10 ? mStart : `0${mStart}`

                        let hourStart = `${hStart}:${mStart}`

                        // console.log('hourStart :>> ', hourStart);
                        // console.log('hourEnd :>> ', hourEnd);

                        let minDifference = this.hourDifferenceInSeconds(hourStart, hourEnd)

                        console.log('minDifference :>> ', minDifference);


                        aplicatiiIdleAll[k].seconds_used = minDifference

                        aplicatiiIdleFilter.push(aplicatiiIdleAll[k])
                    }else if( new Date(aplicatiiIdleAll[k].start_datetime).getHours() === j - 1 && new Date(aplicatiiIdleAll[k].end_datetime).getHours() === j ){

                        let hourEnd = (j) >= 10 ? `${j}:00` : `0${j}:00`
                        let hStart = new Date(aplicatiiIdleAll[k].start_datetime).getHours() 

                        hStart = hStart >= 10 ? hStart : `0${hStart}`

                        let mStart = new Date(aplicatiiIdleAll[k].start_datetime).getMinutes()

                        mStart =  mStart >= 10 ? mStart : `0${mStart}`

                        let hourStart = `${hStart}:${mStart}`

                        // console.log('hourStart :>> ', hourStart);
                        // console.log('hourEnd :>> ', hourEnd);

                        let minDifference = this.hourDifferenceInSeconds(hourStart, hourEnd)

                        // console.log('minDifference :>> ', minDifference);


                        aplicatiiIdleAll[k].seconds_used = minDifference

                        aplicatiiIdleFilter.push(aplicatiiIdleAll[k])
                    }else if(new Date(aplicatiiIdleAll[k].start_datetime).getHours() === j - 1 && new Date(aplicatiiIdleAll[k].end_datetime).getHours() === j + 1){
                        let hourEnd = (j + 1) >= 10 ? `${j+ 1}:00` : `0${j + 1}:00`
                      
                        let hourStart = j >= 10 ? `${j}:00` : `0${j}:00`

                        // console.log('hourStart :>> ', hourStart);
                        // console.log('hourEnd :>> ', hourEnd);

                        let minDifference = this.hourDifferenceInSeconds(hourStart, hourEnd)

                        // console.log('minDifference :>> ', minDifference);


                        aplicatiiIdleAll[k].seconds_used = minDifference

                        aplicatiiIdleFilter.push(aplicatiiIdleAll[k])
                    }

                }


                let aplicatiiIdle =  aplicatiiIdleFilter.reduce((a, c) => {
                        return a + c.seconds_used
                    }, 0)

                // let aplicatiiIdle = aplicatiiFolosite.filter(aa => Number(aa.id_user) === Number(ang[i].id_user) && aa.app_id === "i0000000000000000000000000000000" && new Date(aa.start_datetime).getHours() === j).reduce((a, c) => {
                //     return a + c.seconds_used
                // }, 0)


                let aplicatiiProductiveSecunde = aplicatiiOra.filter(aa => aa.is_productive === 1).reduce((a, c) => {
                    return a + c.seconds_used
                }, 0)

                let aplicatiiNeproductiveSecunde = aplicatiiOra.filter(aa => aa.is_productive === 0).reduce((a, c) => {
                    return a + c.seconds_used
                }, 0)


// console.log('aplicatiiIdle :>> ', aplicatiiIdle);

                let appIdleProcent = (aplicatiiIdle /  3600) * 100
                let appNeproductiveProcent = (aplicatiiNeproductiveSecunde /  3600) * 100
                let appProductiveProcent = (aplicatiiProductiveSecunde /  3600) * 100

                let hToPush = {
                    hour:j,
                    appProductive:appProductiveProcent || 0,
                    appNeproductive:appNeproductiveProcent || 0,
                    appIdle:appIdleProcent || 0,
                    appProductiveMinutes: Math.ceil(aplicatiiProductiveSecunde / 60) ,
                    appNeproductiveMinutes:Math.ceil(aplicatiiNeproductiveSecunde / 60), 
                    appIdleMinutes:Math.ceil(aplicatiiIdle / 60) ,
                    pauzaOraProcent: (p / 60) * 100,
                    appProductiveTime:aplicatiiProductiveSecunde,
                    appNeproductiveTime:aplicatiiNeproductiveSecunde,
                    appIdleTime:aplicatiiIdle,
                    pauzaOraTime:p

                }

                // console.log('hToPush :>> ', hToPush);

                ang[i]['productivity_hourly'].push(hToPush)
                

            }


            // console.log('ang[i][productivity_hourly] :>> ', ang[i]['productivity_hourly']);

         



            // console.log('ang[i].aplicatii_folosite :>> ', ang[i].aplicatii_folosite_merged);
            // console.log('ang[i].aplicatii_folosite_principale :>> ', ang[i].aplicatii_folosite_principale);


            ang[i].aplicatii = newAplicatii.sort((a, b) => {
                if (a.secunde > b.secunde) {
                    return -1
                } else {
                    return 1
                }
            })

           

        }

        

        return ang
    }


    oreLucruDefault = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']


    tipuriBilant = [
        { id: 'Micro', nume: 'Microintreprindere' },
        { id: 'Mediu', nume: 'Intreprindere Medie' },
        { id: 'Macro', nume: 'Macrointreprindere' }
    ]


    languages = [
        { id: 'ro', name: 'Romana' },
        { id: 'en', name: 'Engleza' }
    ]




    formatNumber = (nr, separatorMiimi = '.', separatorZecimale = ',', zecimaleMandatory = true) => {
        // 1234567.15 =>  1.234.567,15
        // console.log('numar primit ', nr)
        let isNegative = false
        // START closure
        function f(intreg) {

            let miime = []
            let newString = ''

            for (let i = intreg.length - 1; i >= 0; i--) {

                miime.push(intreg[i])

                if (miime.length === 3) {

                    newString += miime.join("")

                    if (i !== 0) {
                        newString += separatorMiimi
                    }
                    miime = []
                }

                if (i === 0) {
                    newString += miime.join("")
                }

            }

            return newString
        }
        // END closure

        // daca primeste null / undefined returneaza 0
        if (nr != 0 && !nr) {
            console.error('Masks - formatNumber() - eroare numar primit')
            return 0;
        }

        // daca primeste un string, il intoarce tot pe acela
        if (typeof nr == 'string') {
            return nr
        }

        nr = String(nr);

        // verificam daca umarul este negativ, si ii stergem minusul, pentru a-l adauga la final
        if (nr && nr.indexOf('-') === 0) {
            isNegative = true
            nr = nr.replace("-", "")
        }

        let isPunct = nr.indexOf(".") === -1 ? false : true
        let newString = ''

        if (isPunct) {
            // let nrPuncte = Math.floor(Number(intreg) / 3)

            let intreg = nr.split('.')[0]
            let zecimale = nr.split('.')[1]

            let _newStr = f(intreg).split("").reverse().join("")

            if (zecimale.length == 1) {
                zecimale += '0'
            } else if (zecimale.length === 0) {
                zecimale += '00'
            }

            if (isNegative) {
                newString = "-" + _newStr + separatorZecimale + zecimale
            } else {
                newString = _newStr + separatorZecimale + zecimale
            }

        } else {

            newString = f(nr).split("").reverse().join("");

            if (isNegative) {
                newString = "-" + newString
            }

            if (zecimaleMandatory) {
                newString = newString + separatorZecimale + '00'
            }

        }

        return newString;

    }


returnPauzaInterval = (prg, dataAzi , intervalZile = null) => {
    let dayToday = new Date(dataAzi).getDay()

    console.log('dayToday :>> ', dayToday);
    console.log('prg :>> ', prg);
    let pauze = []

    if(dayToday === 0){

        if(prg.length > 0){

         

            let pauzaStart = prg[0].du_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].du_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}

      

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else if(dayToday === 1){
        if(prg.length > 0){

           
            let pauzaStart = prg[0].lu_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].lu_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);
           if(intervalZile){
            minutes = minutes * intervalZile
        }

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else if(dayToday === 2){
        if(prg.length > 0){

           
            let pauzaStart = prg[0].ma_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].ma_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);
           if(intervalZile){
            minutes = minutes * intervalZile
        }

           console.log('pauzaTimp :>> ', minutes);

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else if(dayToday === 3){
        
        if(prg.length > 0){

          
            let pauzaStart = prg[0].mi_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].mi_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);


           if(intervalZile){
            minutes = minutes * intervalZile
        }

           console.log('pauzaTimp :>> ', minutes);

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else if (dayToday === 4){
        if(prg.length > 0){

            
            let pauzaStart = prg[0].jo_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].jo_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);
           if(intervalZile){
            minutes = minutes * intervalZile
        }

           console.log('pauzaTimp :>> ', minutes);

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else if(dayToday === 5){
        if(prg.length > 0){

            let pauzaStart = prg[0].vi_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].vi_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);
           if(intervalZile){
            minutes = minutes * intervalZile
        }

           console.log('pauzaTimp :>> ', minutes);

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }else{
        if(prg.length > 0){

            
            let pauzaStart = prg[0].sa_pauza_start || "13:30:00"
            let pauzaEnd = prg[0].sa_pauza_end || "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);
           if(intervalZile){
            minutes = minutes * intervalZile
        }

           console.log('pauzaTimp :>> ', minutes);

           return {pauza_start:pauzaStart, time:minutes}

        }else{
            let pauzaStart = "13:30:00"
            let pauzaEnd =  "14:00:00"

           let pauzaTimp =  Math.abs(new Date(`2011/10/09 ${pauzaEnd}`) - new Date(`2011/10/09 ${pauzaStart}`));
           var minutes = Math.floor((pauzaTimp/1000)/60);

           console.log('pauzaTimp :>> ', minutes);

           if(intervalZile){
               minutes = minutes * intervalZile
           }

          return {pauza_start:pauzaStart, time:minutes}
        }
    }


}


    returnOreLucruInterval = (prg, dataAzi) =>{
        let ore = []
            
        let dayToday = new Date(dataAzi).getDay()
          let pauze = []


          

        if(dayToday === 0){

            if(prg.length > 0){

                let oraStart = prg[0].du_start
                let oraFinish = prg[0].du_end

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else if(dayToday === 1){
            if(prg.length > 0){

                let oraStart = prg[0].lu_start
                let oraFinish = prg[0].lu_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                        ore.push(oraStartNumber + i )

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else if(dayToday === 2){
            if(prg.length > 0){

                let oraStart = prg[0].ma_start
                let oraFinish = prg[0].ma_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                        ore.push(oraStartNumber + i )

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else if(dayToday === 3){
            if(prg.length > 0){

                let oraStart = prg[0].mi_start
                let oraFinish = prg[0].mi_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                        ore.push(oraStartNumber + i )

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else if (dayToday === 4){
            if(prg.length > 0){

                let oraStart = prg[0].jo_start
                let oraFinish = prg[0].jo_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                        ore.push(oraStartNumber + i )

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else if(dayToday === 5){
            if(prg.length > 0){

                let oraStart = prg[0].vi_start
                let oraFinish = prg[0].vi_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                        ore.push(oraStartNumber + i )

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }else{
            if(prg.length > 0){

                let oraStart = prg[0].sa_start
                let oraFinish = prg[0].sa_end

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`

                       
                            ore.push(oraStartNumber + i )
                        

                    }

                }

            }else{
                let oraStart = '8:00'
                let oraFinish = '18:00'

             

                if(oraStart){

                    let oraStartNumber = Number(oraStart.substring(0,2))
                    let oraFinishNumber = Number(oraFinish.substring(0,2))


                    


                

                    console.log('oraStart :>> ', oraStartNumber);
                    console.log('oraFinish :>> ', oraFinishNumber);

                    for(let i = 0 , n = oraFinishNumber - oraStartNumber; i <= n ; i++){

                        let oSt = oraStartNumber + i < 10 ? `0${oraStartNumber + i}:00`  : `${oraStartNumber + i}:00`
                        let oFs = (oraStartNumber + i + 1 ) < 10 ? `0${oraStartNumber + i + 1}:00`  : `${oraStartNumber + i + 1}:00`


                        ore.push(oraStartNumber + i )

                     



                    }

                    

                }
            }
        }

        return ore
    }


    round(value, exp) {
        if (typeof exp === 'undefined' || +exp === 0)
          return Math.round(value);
      
        value = +value;
        exp = +exp;
      
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
          return NaN;
      
        // Shift
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
      
        // Shift back
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
      }


   
}